import React from 'react';
import * as ReactDOM from 'react-dom';

interface Props {
  children: React.ReactNode;
}

class PortalWrapper extends React.Component<Props> {
  el: HTMLDivElement = document.createElement('div');

  componentDidMount() {
    document.body.appendChild(this.el);
  }

  componentWillUnmount() {
    document.body.removeChild(this.el);
  }

  render() {
    const { children } = this.props;

    return ReactDOM.createPortal(children, this.el);
  }
}

export const Portal = ({ children }: Props) => {
  return <PortalWrapper>{children}</PortalWrapper>;
};
